import React from 'react'
import Layout from '../../components/web/Layout'
import BreadCrump from '../../components/web/breadcrump/BreadCrump'
import DownloadApply from '../../components/web/form/DownloadApply'

function DownloadApplyPage() {
    return (
        <Layout>
            <BreadCrump />
            <DownloadApply/>

        </Layout>
    )
}

export default DownloadApplyPage
